import React, { useEffect } from 'react';
import {useSelector } from 'react-redux';
import Sidebar from './sidebar/Sidebar';
import Homescreen from './screen/Homescreen/Homescreen';
import { useHistory } from 'react-router-dom';
import randomstring from 'randomstring';
export default function Home() {
    const style={
        display:"flex"
      }
//    const history = useHistory();  
//    const accessToken = localStorage.getItem('accesstoken');
//    useEffect(() => {
//      if(!accessToken){
//          history.push('/');
//      }
//    }, [])
useEffect(() => {
    console.log(randomstring.generate());
}, [])
    return (
        <div>
            <div className="app_container" style={style}>
                <Sidebar />
                <Homescreen />
            </div>
        </div>
    )
}
